import { AlertCircle } from 'lucide-react';

export function ErrorScreen({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="card max-w-sm w-full p-6 text-center">
        <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-3" />
        <h2 className="text-lg font-semibold mb-2">เกิดข้อผิดพลาด</h2>
        <p className="text-sm text-gray-600">{message}</p>
        <button onClick={onRetry ?? (() => window.location.reload())} className="btn-primary mt-4 w-full">
          ลองใหม่
        </button>
      </div>
    </div>
  );
}
